var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description-header"},[_c('h1',{attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.jewel.title))]),_vm._v(" "),_c('p',{staticClass:"materials",attrs:{"itemprop":"material"}},[_vm._v("\n    "+_vm._s(_vm.jewel.material)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3b6cba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionHeader.vue
// module id = null
// module chunks = 